module.exports = __webpack_public_path__ + "media/images/flags/1x1/can-590ff6795e88acd8205def78a5cc6ee8.svg";